import { render } from "./ExpirationWarning.vue?vue&type=template&id=eb157cca&scoped=true"
import script from "./ExpirationWarning.vue?vue&type=script&lang=js"
export * from "./ExpirationWarning.vue?vue&type=script&lang=js"

import "./ExpirationWarning.vue?vue&type=style&index=0&id=eb157cca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-eb157cca"

export default script